import moment from 'moment-timezone';
import * as actionTypes from "../actionTypes";
import {runActionMap} from "../reducerFunctions";

const initialState = {
    loading:       false,
    calendarsFor:  null,
    calendars:     null,
    loadedAt:      null,
    saving:        false,
    saveSuccess:   false,
    skipping:      false,
    skipSuccess:   false,
    removing:      false,
    removeSuccess: false
};

const load        = (state, action) => ({...state, loading: true, calendarsFor: action.forCaretaker, calendars: null, loadedAt: null});
const loadSuccess = (state, action) => ({...state, loading: false, calendarsFor: action.forCaretaker, calendars: action.calendars, loadedAt: moment()});
const loadFail    = (state, action) => ({...state, loading: false});

const saveAppointment = (state, action) => ({...state, saving: true, saveSuccess: false});
const saveBirthday    = (state, action) => ({...state, saving: true, saveSuccess: false});
const saveReminder    = (state, action) => ({...state, saving: true, saveSuccess: false});
const saveTvShow      = (state, action) => ({...state, saving: true, saveSuccess: false});
const saveSuccess     = (state, action) => ({...state, saving: false, saveSuccess: true});
const saveFail        = (state, action) => ({...state, saving: false, saveSuccess: false});
const clearSave       = (state, action) => ({...state, saving: false, saveSuccess: false});

const skip        = (state, action) => ({...state, skipping: true, skipSuccess: false});
const unskip      = (state, action) => ({...state, skipping: true, skipSuccess: false});
const skipSuccess = (state, action) => ({...state, skipping: false, skipSuccess: true});
const skipFail    = (state, action) => ({...state, skipping: false, skipSuccess: false});
const clearSkip   = (state, action) => ({...state, skipping: false, skipSuccess: false});

const remove        = (state, action) => ({...state, removing: true, removeSuccess: false});
const removeSuccess = (state, action) => ({...state, removing: false, removeSuccess: true});
const removeFail    = (state, action) => ({...state, removing: false, removeSuccess: false});
const clearRemove   = (state, action) => ({...state, removing: false, removeSuccess: false});

const clear = (state, action) => ({...state, loading: false, calendarsFor: null, calendars: null});

const actionMap        = {
    [actionTypes.CALENDARS_LOAD]:            load,
    [actionTypes.CALENDARS_LOAD_SUCCESS]:    loadSuccess,
    [actionTypes.CALENDARS_LOAD_FAIL]:       loadFail,
    [actionTypes.CALENDARS_UNLOAD]:          clear,
    [actionTypes.CALENDAR_SAVE_APPOINTMENT]: saveAppointment,
    [actionTypes.CALENDAR_SAVE_BIRTHDAY]:    saveBirthday,
    [actionTypes.CALENDAR_SAVE_REMINDER]:    saveReminder,
    [actionTypes.CALENDAR_SAVE_TVSHOW]:      saveTvShow,
    [actionTypes.CALENDAR_SAVE_SUCCESS]:     saveSuccess,
    [actionTypes.CALENDAR_SAVE_FAIL]:        saveFail,
    [actionTypes.CALENDAR_SAVE_CLEAR]:       clearSave,
    [actionTypes.CALENDAR_SKIP]:             skip,
    [actionTypes.CALENDAR_UNSKIP]:           unskip,
    [actionTypes.CALENDAR_SKIP_SUCCESS]:     skipSuccess,
    [actionTypes.CALENDAR_SKIP_FAIL]:        skipFail,
    [actionTypes.CALENDAR_SKIP_CLEAR]:       clearSkip,
    [actionTypes.CALENDAR_REMOVE]:           remove,
    [actionTypes.CALENDAR_REMOVE_SUCCESS]:   removeSuccess,
    [actionTypes.CALENDAR_REMOVE_FAIL]:      removeFail,
    [actionTypes.CALENDAR_REMOVE_CLEAR]:     clearRemove,
    [actionTypes.CALENDAR_LIST_CLEAR]:       clear
};
const calendarsReducer = (state = initialState, action) => runActionMap(state, action, actionMap);

export default calendarsReducer;
